var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"message"},[_c('h1',[_vm._v("404")]),_vm._v(" "),_c('p',[_vm._v("La página no fue encontrada")]),_vm._v(" "),_c('button',{staticClass:"btn",on:{"click":_vm.goBack}},[_vm._v("\n      Ir atrás\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b15cfab4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/page-not-found.view.vue
// module id = null
// module chunks = 